import StepThree from "@/components/dashboard/withdrawMoney/StepThree";

export default function WithdrawMoneyStepThree() {
  return <StepThree />;
}
